package com.vizio.redwolf.dms.model

import kotlinx.serialization.Serializable

@Serializable
data class UnregisterDeviceRequestBody(val deviceId: String)
